import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { fadeInOnEnterAnimation } from 'angular-animations';
import { ClassificationInfo } from 'src/app/_models/classificationInfo';
import { ClassificationService } from '../../_services/classification.service';
import { NotifyService } from 'src/app/_services/notify.service';
import { Observable, of } from 'rxjs';

@Component({
   selector: 'app-classification-select',
   templateUrl: './classification-select.component.html',
   styleUrls: ['./classification-select.component.scss'],
   animations: [fadeInOnEnterAnimation()],
})
export class ClassificationSelectComponent implements OnInit {
   loading: boolean;
   opened = false;
   classifications: ClassificationInfo[];
   selectedClass: ClassificationInfo;
   @Output()
   dialogClose: EventEmitter<ClassificationInfo> = new EventEmitter<ClassificationInfo>();
   constructor(private classService: ClassificationService, private notify: NotifyService) {}
   public fetchChildren(node: any): Observable<any[]> {
      return of(node.items);
   }

   public hasChildren(node: any): boolean {
      return node.items && node.items.length > 0;
   }
   public iconClass({ text, items }: any): any {
      return {
         'k-i-folder': items.length > 0,
         'k-i-html': items.length === 0,
         'k-icon': true,
      };
   }
   public handleSelection({ dataItem }: any): void {
      this.selectedClass = dataItem;
      if (this.selectedClass.items.length === 0) {
         this.dialogClose.emit(this.selectedClass);
         this.opened = false;
      } else {
         const message = 'Please choose the lowest classification level';
         this.notify.warning(message);
      }
   }
   ngOnInit() {
      this.classService.popupClassSelected.subscribe(() => {
         this.opened = true;
         this.loadClassifications();
      });
   }
   loadClassifications() {
      this.loading = true;
      this.classService.getClassifications().subscribe(
         (res: ClassificationInfo[]) => {
            this.classifications = res;
         },
         (error) => {
            const message = error;
            this.notify.error(message);
         },
         () => {
            this.loading = false;
         }
      );
   }
   close() {
      this.opened = false;
   }
}
